import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import type { IMenuItem } from 'src/lib/types/Settings';
import styles from './DropDownMenu.module.css';
import { getUrlForDoctype } from "src/lib/types/sanity";
import usePopover from "src/lib/client/usePopover";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type DropDownMenuProps = {
  id?: string;
  menuItems?: IMenuItem[];
  isVisible: boolean;
  /** the browser closed the menu by itself (click outside, Esc) */
  onBrowserClose?: () => void;
  forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
// A popover: shown above the page, closed by a click outside or Esc. The 'visible' class is the fallback for browsers without the Popover API.
export default function DropDownMenu(t0) {
  const $ = _c(15);
  const {
    id,
    menuItems,
    isVisible,
    onBrowserClose,
    forceHardlinks: t1
  } = t0;
  const forceHardlinks = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      belowParent: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const popoverRef = usePopover(isVisible, onBrowserClose, t2);
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  let t3;
  if ($[1] !== isVisible) {
    t3 = classNames(styles.SDropDownWrapper, {
      "visible": isVisible
    });
    $[1] = isVisible;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== forceHardlinks || $[4] !== menuItems) {
    let t5;
    if ($[6] !== forceHardlinks) {
      t5 = mi => {
        let isEaster = false;
        const text = mi.text ?? mi.menuReference?.title;
        if (BRAND === "filmweb" && text.toLocaleLowerCase().includes("p\xE5ske")) {
          isEaster = true;
        }
        let url = mi.url;
        if (mi.menuReference) {
          url = getUrlForDoctype(mi.menuReference._type, mi.menuReference.slug?.current, mi.menuReference.isStreaming, mi.menuReference);
        }
        if (!url) {
          return null;
        }
        return <FilmwebLink key={mi._key} to={url} className={classNames(styles.SMenuItem, {
          "easter": isEaster
        })} hardLink={forceHardlinks}>{text}</FilmwebLink>;
      };
      $[6] = forceHardlinks;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = menuItems.map(t5);
    $[3] = forceHardlinks;
    $[4] = menuItems;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <nav className={styles.SMenuItems}>{t4}</nav>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== id || $[11] !== popoverRef || $[12] !== t3 || $[13] !== t5) {
    t6 = <div id={id} ref={popoverRef} popover="auto" className={t3}>{t5}</div>;
    $[10] = id;
    $[11] = popoverRef;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
//#endregion